export default class Form {

	constructor () {
		const forms = document.getElementsByTagName('form');

		for (let i = 0, l = forms.length; i < l; ++i)
			this.initForm(forms[i]);
	}

	// Initializers
	// =========================================================================

	initForm (form) {
		const submit = form.querySelector('button[type="submit"]');
		const inputs = form.querySelectorAll('textarea, select, input');

		form._submit = submit;

		for (let i = 0, l = inputs.length; i < l; ++i)
			this.initInput(form, inputs[i]);
	}

	initInput (form, input) {
		if (!input.dataset.hasOwnProperty('message'))
			return;

		input.addEventListener('input', this.onInput.bind(this, form, input));
		input.addEventListener('invalid', this.onInputInvalid.bind(this, input));
	}

	// Actions
	// =========================================================================

	validate (form) {
		form._submit.classList[form.checkValidity() ? 'add' : 'remove']('valid');
	}

	// Events
	// =========================================================================

	onInput = (form, input) => {
		input.setCustomValidity('');
		this.validate(form);

		if (input.type === 'file') {
			const span = input.nextElementSibling;

			if (input.files.length) span.textContent = input.files[0].name;
			else span.textContent = span.dataset.label;
		}
	};

	onInputInvalid = input => {
		if (input.value.trim() === '')
			input.setCustomValidity(input.dataset.message);
	};

}